import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
import { theme } from '../../themes/theme';
export default css `
    ${componentStyles}

    :host {
        display: block;
        height: 3.5em;
    }

    .sgdf-navbar {
        ${theme.texts.cssBody('semibold')};
        display: flex;
        background-color: var(--sgdf-color-default);
        width: 100%;
        overflow: hidden;
        height: 100%;
        justify-content: space-between;
    }

    .sgdf-navbar-links {
        display: flex;
        align-items: center;
        flex: 1;
        height: 100%;
    }

    .sgdf-navbar-mobile {
        ${theme.texts.cssBody('semibold')};
        display: flex;
        align-items: center;
        background-color: var(--sgdf-color-default);
        width: 100%;
        justify-content: space-between;
    }

    .drawer-menu::part(panel) {
        background-color: var(--sgdf-color-default);
    }

    .drawer-menu::part(close-button),
    .drawer-menu::part(title) {
        color: white;
    }

    .sgdf-navbar:focus {
        outline: none;
    }

    .nav-item-mobile {
        display: flex;
        color: white;
        align-items: center;
        padding: var(--sgdf-spacing-medium);
    }

    .clickable {
        cursor: pointer;
    }

    .nav-item-mobile:hover {
        background-color: var(--mode-color-hover);
    }

    .sticky {
        position: fixed;
        width: 100%;
        height: 3.5em;
        z-index: 100;
    }
`;
//# sourceMappingURL=NavBar.styles.js.map